module.exports = __webpack_public_path__ + "img/logo.3aacbb5b.png";